



















import Vue from 'vue';
import { Field, User } from '../types';
import EditorField from './EditorField.vue';

export default Vue.extend({
  components: {
    EditorField,
  },
  props: {
    fields: {
      type: Array as () => Field[],
      required: true,
    },
    trackChanges: {
      type: Boolean,
      default: false,
    },
    manageTrackedChanges: {
      type: Boolean,
      default: false,
    },
    sharedToolbar: {
      type: Boolean,
      default: false,
    },
    user: Object as () => User,
  },
  methods: {
    updateField(field: Field) {
      const index = this.fields.findIndex((f: Field) => f.id === field.id);
      if (index >= 0) {
        this.$emit('change', field);
      }
    },
  },
});
